import axios from "axios";

axios.interceptors.request.use(function(config) {
  if (typeof config.params === "undefined") {
    config.params = {};
  }
  if (typeof config.params === "object") {
    if (
      typeof URLSearchParams === "function" &&
      config.params instanceof URLSearchParams
    )
      config.params.append("_", Date.now());
    else config.params._ = Date.now();
  }
  // config.headers.common['Accept-Language'] = 'en';

  config.headers.common["Accept-Language"] = sessionStorage.getItem('AcceptLanguage');
  return config;
});

const axiosEx = (options) => {
  // alert(JSON.stringify(options))
  return axios(options)
    .then((res) => {
      return res.data;
    })
    .then((data) => {
      return { data };
    })
    .catch((error) => {
      return { error };
    });
};

export default axiosEx;
